import { bearerAuth } from "../standardAuthPatterns";
import { defineProduct, productVariant } from "../types";
import { oauthSetupSteps } from "../oauthSetupSteps";
import { oauthAuth } from "../standardAuthPatterns";
import logo from "./logo.svg";

const credential = productVariant({
  authLabel: "Access token",
  identifier: "vercel",
  keywords: "zeit now nextjs hosting deployments serverless edge functions",
  protocol: "http",
  defaultUrlPattern: () => "https://api\\.vercel\\.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Create an access token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [Vercel Account Settings](https://vercel.com/account/tokens) and create a new token.\n\nGive it a descriptive name and select the appropriate scope for your use case.",
        },
      ],
    },
    {
      title: "Enter your access token",
      items: [
        {
          kind: "input",
          label: "Access token",
          placeholder: "Your Vercel access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.vercel.com/v10/projects",
  },
});

export const vercel = defineProduct({
  name: "Vercel",
  tagLine: "Frontend deployment platform",
  logo,
  tags: ["engineering"],
  variants: [
    credential,
    productVariant({
      identifier: "vercelOAuth",
      authLabel: "OAuth",
      protocol: "http",
      defaultUrlPattern: () => "https://api\\.vercel\\.com/.*",
      auth: oauthAuth,
      steps: oauthSetupSteps({
        identifier: "vercelOAuth",
        registrationUrl: "https://vercel.com/dashboard/integrations/console",
        scopes: ["openid", "offline_access"],
        instructions: "",
      }),
      oauth: {
        grantType: () => "authorization_code",
        authorizationEndpoint: () => "https://vercel.com/oauth/authorize",
        tokenEndpoint: () => "https://api.vercel.com/login/oauth/token",
        tokenEndpointAuthMethod: () => "client_secret_post",
        clientCredentialsFrom: "db",
        scopes: () => ["openid", "offline_access"],
        pkce: () => true,
      },
      connectionTest: {
        protocol: "http",
        request: () => ({
          url: "https://api.vercel.com/login/oauth/userinfo",
          method: "POST",
        }),
      },
    }),
  ],
});
